document.addEventListener('click', function (e) {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;

  const wrapper = btn.closest('.quantity-selector');
  const input = wrapper.querySelector('.quantity-input');

  let qty = parseInt(input.value, 10) || 1;
  const min = 1;

  if (btn.classList.contains('qty-increase')) {
    qty++;
  }

  if (btn.classList.contains('qty-decrease')) {
    qty = Math.max(qty - 1, min);
  }

  input.value = qty;
  updateCartQuantity(wrapper.dataset.lineKey, qty, wrapper);
});

document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('quantity-input')) return;

  const wrapper = e.target.closest('.quantity-selector');
  let qty = parseInt(e.target.value, 10) || 1;

  updateCartQuantity(wrapper.dataset.lineKey, qty, wrapper);
});

/* ===========================
   AJAX CART UPDATE
=========================== */
function updateCartQuantity(lineKey, quantity, wrapper) {
  wrapper.classList.add('is-loading');

  const sections = getSectionsToRender();

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: lineKey,
      quantity: quantity,
      sections: sections.map(s => s.section),
      sections_url: window.location.pathname
    })
  })
    .then(res => res.json())
    .then(state => {
      sections.forEach(section => {
        const parsedHTML = new DOMParser()
          .parseFromString(state.sections[section.section], 'text/html');

        const newContent = parsedHTML.querySelector(section.selector);
        const currentContent = document.querySelector(section.selector);

        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      });

      updateCartCount(state.item_count);
    })
    .catch(console.error)
    .finally(() => {
      wrapper.classList.remove('is-loading');
    });
}

/* ===========================
   SECTIONS TO UPDATE
=========================== */
function getSectionsToRender() {
  return [
    {
      section: document.querySelector('#CartItemsBody')?.dataset.sectionId,
      selector: '#CartItemsBody'
    },
    {
      section: document.querySelector('#CartFooter')?.dataset.sectionId,
      selector: '#CartFooter'
    }
  ].filter(s => s.section);
}

/* ===========================
   HEADER CART COUNT
=========================== */
function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
  });
}
